module.exports = __webpack_public_path__ + "media/images/icons/icon-scroll-arrow-24e346a4724e097197d45edb6c0956f4.svg";